<div class="relative" [class.w-full]="fullWidth" [class.pb-6]="shouldReserveHintSpace">
  <input
    [type]="type"
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    [ngClass]="computedClasses"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [attr.pattern]="forceInvalid ? '(?!)' : null"
    class="pr-10"
  />

  @if (showHint && hint) {
    <!-- DaisyUI validator requires the hint to be an immediate sibling of the input.
         We position it absolutely so it doesn't affect the clear button centering. -->
    <p class="validator-hint absolute left-0">{{ hint }}</p>
  }

  @if (showClearButton) {
    <button
      type="button"
      class="absolute right-2 top-5 -translate-y-1/2 btn btn-ghost btn-sm btn-circle"
      (click)="onClear()"
      [attr.aria-label]="'Clear ' + (ariaLabel || 'input')"
    >
      ×
    </button>
  }
</div>
